export const migrateFabricJSON = (json) => {
  if (json.version && parseFloat(json.version) >= 6) {
    return json
  }
  if (!json.state || !json.state.objects) {
    return { version: '6.6.1', objects: [] }
  }

  const result = {
    version: '6.6.1',
    objects: json.state.objects,
    width: json.canvasWidth || 1920,
    height: json.canvasHeight || 1080
  }

  // Обрабатываем фон
  if (json.state.background) {
    result.backgroundColor = json.state.background
  } else if (json.state.backgroundImage) {
    // Сохраняем данные о фоновом изображении для последующей обработки
    result._backgroundPattern = {
      src: json.state.backgroundImage.src,
      repeat: json.state.backgroundImage.repeat || 'no-repeat'
    }
    // Временно ставим белый фон
    result.backgroundColor = '#ffffff'
  } else {
    result.backgroundColor = '#ffffff'
  }

  return result
}
